import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Tayla",
    quote: "Fitness Portal Gym offers excellent facilities and a welcoming atmosphere. The gym is well-equipped, providing everything you need for a great workout experience. The staff are always friendly and approachable, creating a positive environment for all members. For the value you get, it's hard to beat – highly recommended for anyone looking for a quality gym that doesn't break the bank",
    rating: 5
  },
  {
    name: "Sussan",
    quote: "The best gym in Auckland. Huge range of equipment, great facilities (pool, sauna, ice baths), well maintained, very welcoming staff and environment. Every piece of feedback is taken on board - the owners are so proactive and constantly making changes to improve member's experience. Couldn't recommend enough",
    rating: 5
  },
  {
    name: "Keagan",
    quote: "I've been going to Fitness Portal for over a year now, and it's easily the best gym I've ever been a part of. The facilities are top-notch—everything from the sauna, pool, and ice bath to the great gym equipment. It's a place that caters to all your fitness needs. What really sets it apart, though, is the team. They're incredibly welcoming, supportive of your goals, and just great people to be around. Special shoutout to Brian at reception—always such a cheerful and friendly face to see when you walk in—and to Hagos, the GOAT, who makes sure everything and everyone is looked after",
    rating: 5
  },
  {
    name: "Nick",
    quote: "This is a fantastic gym and exactly what I've been looking for in Central Auckland. Exceptionally well kitted out with new and modern equipment for every type of strength training, functional training and cardio, and generally not very busy. Great facilities including sauna, steam room, pool and ice bath. Really glad to have discovered this gem and would highly recommend",
    rating: 5
  },
  {
    name: "Elizabeth",
    quote: "The gym stands out with extra amenities, including a small 2 lane indoor pool, separate male/female steam rooms and saunas, (rare) towel service, ample free parking, group classes, a relatively uncrowded environment, and the cafe inside also helps with gym munchies. Its at a convenient location, especially for those in Mt Eden and New Market",
    rating: 5
  }
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);

  const next = () => {
    setDirection(1);
    setCurrentIndex((current) => (current + 1) % testimonials.length);
  };

  const prev = () => {
    setDirection(-1);
    setCurrentIndex((current) => (current - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold mb-4">MEMBER STORIES</h2>
          <p className="text-xl text-gray-400">Hear from our community</p>
        </motion.div>

        <div className="relative">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={currentIndex}
              initial={{ opacity: 0, x: direction * 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -direction * 100 }}
              transition={{ duration: 0.5 }}
              className="relative bg-gradient-to-br from-blue-500/10 to-cyan-500/10 backdrop-blur-sm rounded-2xl p-8 sm:p-12 border border-white/10"
            >
              <div className="relative">
                <div className="absolute -top-6 -left-6">
                  <Quote className="w-12 h-12 text-blue-400/20" />
                </div>

                <div className="flex mb-6">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>

                <blockquote className="text-xl sm:text-2xl font-medium mb-8 leading-relaxed">
                  "{testimonials[currentIndex].quote}"
                </blockquote>

                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
                      {testimonials[currentIndex].name}
                    </p>
                    <p className="text-gray-400">Verified Member</p>
                  </div>

                  <div className="flex items-center space-x-2">
                    <button
                      onClick={prev}
                      className="bg-white/10 p-3 rounded-full hover:bg-white/20 transition-colors"
                    >
                      <ChevronLeft className="w-6 h-6" />
                    </button>
                    <button
                      onClick={next}
                      className="bg-white/10 p-3 rounded-full hover:bg-white/20 transition-colors"
                    >
                      <ChevronRight className="w-6 h-6" />
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/10 via-cyan-500/10 to-blue-500/10 rounded-3xl blur-xl -z-10" />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.8 }}
          className="text-center mt-12"
        >
          <a
            href="https://thefitnessportal.gymmasteronline.com/portal/membership/065f4de9d82bbfa64defc7f658dd2f03"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-cyan-600 px-8 py-4 rounded-full font-bold hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 transform hover:scale-105"
          >
            <span>JOIN OUR COMMUNITY</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
}